import React from 'react';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import './SportOneOurPartners.scss';

const partnerLogos = [
  'https://tournamentplanner.in/screens/image/TPLIVE-FULL-LOGO.png',
  'https://sportfitinc.com/wp-content/uploads/2025/02/LF-HS-SF-1980x283.png',
  'https://static.wixstatic.com/media/16605b_d031ea0c6a984206ad6fd78d4d22f514~mv2.png/v1/fill/w_225,h_94,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/Brighter%20Minds%20Logo%20Colour.png',
  'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR247U5YN0EaM3Wr3hIrStQNU7ivjV7mMS4yg&s',
  'https://cdn-prod.heartfulness.org/images/logo_heartfulness.svg',
  'https://firebasestorage.googleapis.com/v0/b/cloudify-app.appspot.com/o/master_data%2Flogo%2FUntitled%20(1280%20x%20500%20px)%20(800%20x%20500%20px)%20(1).png?alt=media&token=825a251c-b5c2-4b5c-b422-3acb833027ac'
];

const carouselOptions = {
  loop: true,
  margin: 20,
  center: true,
  autoplay: true,
  autoplayTimeout: 2000,
  autoplayHoverPause: true,
  dots: false,
  nav: false,
  responsive: {
    0: {
      items: 1
    },
    600: {
      items: 3
    },
    1000: {
      items: 5
    }
  }
};

const SportOneOurPartners = () => {
  return (
    <section className="sport-one-our-partners-section">
      <h2 className="partners-title">Our Partners</h2>
      <OwlCarousel className="owl-theme partner-carousel" {...carouselOptions}>
        {partnerLogos.map((logo, index) => (
          <div key={index} className="partner-logo-box">
            <img src={logo} alt={`Partner ${index + 1}`} />
          </div>
        ))}
      </OwlCarousel>
    </section>
  );
};

export default SportOneOurPartners;





